(() => {
  'use strict';

  const GIFT_VARIANT_ID = 45555598033075;
  const THRESHOLD = 500000; // Rs 5,000 in Shopify minor units

  let syncing = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    return response.json();
  }

  function getEligibleSubtotal(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === GIFT_VARIANT_ID) {
        return total;
      }

      return total + Number(item.final_line_price || 0);
    }, 0);
  }

  function getGift(cart) {
    return cart.items.find(
      item => Number(item.variant_id) === GIFT_VARIANT_ID
    );
  }

  async function addGift() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Unable to add free tote');
    }

    return response.json();
  }

  async function setGiftQuantity(quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: String(GIFT_VARIANT_ID),
        quantity
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update free tote');
    }

    return response.json();
  }

  async function syncGift() {
    if (syncing) return;

    syncing = true;

    try {
      const cart = await getCart();

      const eligibleSubtotal = getEligibleSubtotal(cart);
      const gift = getGift(cart);

      if (eligibleSubtotal >= THRESHOLD) {
        if (!gift) {
          await addGift();
        } else if (Number(gift.quantity) !== 1) {
          await setGiftQuantity(1);
        }
      } else {
        if (gift) {
          await setGiftQuantity(0);
        }
      }
    } catch (error) {
      console.error('Eazicolor free tote error:', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(delay = 700) {
    setTimeout(() => {
      syncGift();
    }, delay);
  }

  /* Initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleSync(300);
    });
  } else {
    scheduleSync(300);
  }

  /* Quantity + / - and remove */
  document.addEventListener('click', event => {
    const cartAction = event.target.closest(
      '.quantity__button, cart-remove-button button'
    );

    if (!cartAction) return;

    scheduleSync(800);
  });

  /* Manual quantity changes */
  document.addEventListener('change', event => {
    if (!event.target.matches('.quantity__input')) return;

    scheduleSync(800);
  });

  /* Product add-to-cart */
  document.addEventListener('submit', event => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';

    if (action.includes('/cart/add')) {
      scheduleSync(900);
    }
  });

  /* Re-check when user interacts with/open drawer */
  document.addEventListener('click', event => {
    const cartRelated = event.target.closest(
      'cart-drawer, [href="/cart"], .cart-icon, .header__icon--cart, cart-icon'
    );

    if (!cartRelated) return;

    scheduleSync(300);
  });

  /* Final guaranteed check before checkout */
  document.addEventListener('submit', event => {
    const checkoutButton = event.submitter;

    if (!checkoutButton || checkoutButton.name !== 'checkout') {
      return;
    }

    event.preventDefault();

    (async () => {
      try {
        await syncGift();

        await new Promise(resolve => {
          setTimeout(resolve, 250);
        });

        window.location.href = '/checkout';
      } catch (error) {
        console.error('Eazicolor checkout tote error:', error);
        window.location.href = '/checkout';
      }
    })();
  });

  /* Re-check when returning with browser back */
  window.addEventListener('pageshow', () => {
    scheduleSync(300);
  });
})();